type CartListener = () => void;

let listeners: CartListener[] = [];

export const openCart = () => {
  listeners.forEach((l) => l());
};

export const subscribeToCartOpen = (cb: CartListener) => {
  listeners.push(cb);
  return () => {
    listeners = listeners.filter((l) => l !== cb);
  };
};
